import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Table, Spin } from 'antd';
import { getHousesTableColumns } from './utils/getHousesTableColumns';
import useTablePagination from '../../../../hooks/useTablePagination';
import { generateAddress } from '../../../../utils/generateAddress';
import useFilteredBySearchData from '../../../../hooks/useFilteredBySearchData';
import useTableChange from '../../../../hooks/useTableChange';
import { sortableColumnsData } from '../constants/sortableColumnsData';
import { filterableColumnsData } from '../constants/filterableColumnsData';
import {
  generateHouseStageFilters,
  generateHouseTypeFilters,
  generateHouseRegionFilters,
} from '../../../../utils/generateStageTableFilters';
import { useSelector, useDispatch } from 'react-redux';
import { setHousesTablePage } from '../../../../store/actions/housingStockActions';
import { housesTableComponents } from './constants/housesTableComponents';
import { modes } from '../../MainHeader/components/Search';

const { Column } = Table;

const HousesTable = ({ onRowClick, houses, pagination = true, ...props }) => {
  const [houseStages, setHouseStages] = useState([]);
  const [houseTypes, setHouseTypes] = useState([]);
  const [houseRegions, setHouseRegions] = useState([]);
  const { companyId } = useParams();

  const dispatch = useDispatch();

  const housesTablePage = useSelector(
    (state) => state.housingStockStore.housesTablePage
  );

  useEffect(() => {
    let newHouseStages = [];
    let newHouseTypes = [];
    let newHouseRegions = [];

    if (Boolean(houses?.length)) {
      newHouseStages = generateHouseStageFilters(houses);
      newHouseTypes = generateHouseTypeFilters(houses);
      newHouseRegions = generateHouseRegionFilters(houses);
    }

    setHouseStages(newHouseStages);
    setHouseTypes(newHouseTypes);
    setHouseRegions(newHouseRegions);
  }, [houses]);

  const [loading, filteredBySearchHouses] = useFilteredBySearchData({
    data: houses,
    key: generateAddress,
    mode: modes.houses,
  });

  const {
    data: sortedHouses,
    sortedInfo,
    filteredInfo,
    handleTableChange,
  } = useTableChange({
    initialData: filteredBySearchHouses,
    sortableColumnKeys: sortableColumnsData,
    filterableColumnKeys: filterableColumnsData,
    depsToReset: [companyId],
  });

  const { shownItems: shownHouses, pagination: paginationBlock } =
    useTablePagination(sortedHouses, {
      currentPage: housesTablePage,
      setCurrentPage: (page) => dispatch(setHousesTablePage(page)),
    });

  return (
    <Spin spinning={loading}>
      <Table
        {...props}
        dataSource={pagination ? shownHouses : sortedHouses}
        components={housesTableComponents}
        onRow={(record) => ({
          onClick: () => onRowClick(record.houseId),
        })}
        pagination={false}
        onChange={handleTableChange}
      >
        {getHousesTableColumns({
          sortedInfo,
          houseStages,
          houseTypes,
          houseRegions,
          filteredInfo,
        }).map((column) => {
          return <Column {...column} />;
        })}
      </Table>
      {pagination && paginationBlock}
    </Spin>
  );
};

export default HousesTable;
